import PropTypes from 'prop-types';
import { equals } from 'ramda';
import { cx, noop } from 'ramda-extension';

import AngleDown from '@gef-ui/components/atoms/SvgIcon/Icons/AngleDown';
import AngleUp from '@gef-ui/components/atoms/SvgIcon/Icons/AngleUp';

const SortCell = ({ sort = '', sortBy = '', onSort = noop, hasRecords = true, children }) => {
	const handleSort = () => {
		if (sortBy) {
			let asc = '';
			let desc = '';
			if (Array.isArray(sortBy)) {
				asc = sortBy.map((s) => `${s},asc`);
				desc = sortBy.map((s) => `${s},desc`);
			} else {
				asc = `${sortBy},asc`;
				desc = `${sortBy},desc`;
			}

			if (Array.isArray(sort)) {
				onSort(equals(sort, asc) ? desc : asc);
			} else {
				onSort(sort && sort === asc ? desc : asc);
			}
		}
	};

	let mainSortBy = sortBy;
	if (Array.isArray(sortBy)) {
		mainSortBy = sortBy[0];
	}

	let mainSort = sort;
	if (Array.isArray(sort)) {
		mainSort = sort[0];
	}

	const [name, type] = mainSort.split(',');

	return (
		<div
			className={cx({ Link: hasRecords && name === mainSortBy })}
			style={{ cursor: 'pointer' }}
			onClick={hasRecords ? handleSort : noop}
		>
			{children || ''}
			{name === mainSortBy && type === 'desc' ? (
				<AngleUp className="Icon--sort" />
			) : (
				<AngleDown className="Icon--sort" />
			)}
		</div>
	);
};

SortCell.propTypes = {
	children: PropTypes.any,
	hasRecords: PropTypes.bool,
	onSort: PropTypes.func,
	sort: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	sortBy: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default SortCell;
